import React from 'react';
import './WhoThisIsFor.css';

const WhoThisIsFor = () => {
  return (
    <section className="who-section">
      <div className="who-container">
        <h2 className="who-heading">Who This Is For</h2>
        
        <div className="who-columns">
          <div className="who-box success-box">
            <h3>Perfect Fit For:</h3>
            <ul>
              <li>✅ Foreign businesses with products ready to sell</li>
              <li>✅ Brands looking to expand with structure</li>
              <li>✅ Founders seeking long-term growth in India</li>
            </ul>
          </div>

          <div className="who-box warning-box">
            <h3>Not Ideal For:</h3>
            <ul>
              <li>❌ Brands without inventory</li>
              <li>❌ Anyone expecting passive results</li>
              <li>❌ Unwilling to follow a guided system</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsFor;
